<script lang="ts">
  import { getModalStore, getToastStore } from '@skeletonlabs/skeleton'
  import type { SvelteComponent } from 'svelte'

  import CloseModalButton from './CloseModalButton.svelte'
  import Input from './Input.svelte'

  interface Props {
    /** Exposes parent props to this component. */
    parent: SvelteComponent
  }

  let { parent }: Props = $props()

  let deleteTest = $state('')

  const toastStore = getToastStore()
  let activeToast: string | null = null

  const onFormCancel = () => {
    if ($modalStore[0].response) {
      $modalStore[0].response(false)
    }
    modalStore.close()
  }
  const onFormSubmit = () => {
    if (activeToast) {
      toastStore.close(activeToast)
    }

    // the value.name is for deleting storage config
    const expectedName = $modalStore[0].value?.name ?? $modalStore[0].meta

    if (singleItemToDelete) {
      if (deleteTest != expectedName) {
        activeToast = toastStore.trigger({
          message: "You didn't type the name of the item correctly",
          background: 'variant-filled-error',
        })
        return
      }
    } else {
      if (deleteTest != 'DELETE') {
        activeToast = toastStore.trigger({
          message: "You didn't type DELETE correctly",
          background: 'variant-filled-error',
        })
        return
      }
    }
    if ($modalStore[0].response) {
      $modalStore[0].response(true)
    }
    modalStore.close()
  }

  const modalStore = getModalStore()

  const singleItemToDelete = typeof $modalStore[0].meta == 'string'
</script>

{#if $modalStore[0]}
  <div class="card w-modal space-y-4 p-4 shadow-xl" role="dialog">
    <h3 class="h3 sticky top-0 justify-between bg-surface-50 p-4 dark:bg-surface-800">
      {$modalStore[0].title}<CloseModalButton onClose={parent.onClose} />
    </h3>
    <article class="space-y-4 p-4">
      {$modalStore[0].body}
      {#if singleItemToDelete}
        <pre>{$modalStore[0].meta}</pre>
      {:else}
        <ol class="list my-3">
          {#each $modalStore[0].meta as meta, number (meta)}
            <li>
              <span class="variant-soft-primary badge-icon p-4">{number + 1}.</span>
              <span class="flex-auto overflow-x-hidden"><pre>{meta}</pre></span>
            </li>
          {/each}
        </ol>
      {/if}
      {#if singleItemToDelete}
        <p>Please confirm you want to delete this item by typing the name of the item</p>
        <Input type="text" bind:value={deleteTest} />
      {:else}
        <p>Please confirm you want to delete these items by typing "DELETE"</p>
        <Input type="text" bind:value={deleteTest} />
      {/if}
    </article>
    <footer class="modal-footer {parent.regionFooter}">
      <div class="variant-filled-primary btn-group w-min">
        <button class={parent.buttonNeutral} onclick={onFormCancel}
          >{parent.buttonTextCancel}</button
        >
        <button class={parent.buttonPositive} onclick={onFormSubmit}
          >{parent.buttonTextConfirm}</button
        >
      </div>
    </footer>
  </div>
{/if}
